import { AppSelectLocale } from "../index";

const locale: AppSelectLocale = {
  placeholder: "请选择应用",
  title: "应用搜索",
};

export default locale
